/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type PropsWithChildren } from 'react';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

export const WithDragPreview = ({
	children,
	isEnabled,
}: PropsWithChildren & { isEnabled: boolean }): React.JSX.Element => {
	return <Box xcss={isEnabled ? [draggingContanerStyles] : []}>{children}</Box>;
};

const draggingContanerStyles = xcss({
	backgroundColor: 'color.background.neutral.subtle.hovered',
});
